var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('van-nav-bar',{attrs:{"title":"用户服务协议","left-arrow":"","fixed":"","placeholder":"","safe-area-inset-top":""},on:{"click-left":_vm.goBack}}),_c('iframe',{staticClass:"agreement-frame",attrs:{"src":_vm.agreementUrl,"title":"用户服务协议"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }